import { Link } from 'react-router-dom';

const footerLinks = {
  探索: [
    { label: '视觉设计', path: '/category/design' },
    { label: '摄影摄像', path: '/category/photography' },
    { label: '文字创作', path: '/category/writing' },
    { label: '音乐音频', path: '/category/music' },
    { label: '科技创意', path: '/category/tech' },
  ],
  社区: [
    { label: '关于我们', path: '/about' },
    { label: '热门话题', path: '/category/all' },
    { label: '精选作品', path: '/category/all' },
    { label: '社区规范', path: '/about' },
    { label: '帮助中心', path: '/about' },
  ],
  联系: [
    { label: '商务合作', path: '/about' },
    { label: '加入我们', path: '/about' },
    { label: '意见反馈', path: '/about' },
    { label: '媒体报道', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-primary-400 no-underline">
              cy社区
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              创意青年聚集地
              <br />
              发现无限可能
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="小红书">
                <i className="ri-reddit-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-400">
            &copy; {new Date().getFullYear()} cy社区. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">
              隐私政策
            </Link>
            <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline">
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}